<section class="access-card">
  <header class="access-card__header">
    <h3 class="access-card__title">Acesso do cliente</h3>
    @if (!loading() && !errorMessage()) {
      <span
        class="access-card__tag"
        [class.access-card__tag--success]="badge().tone === 'success'"
        [class.access-card__tag--warning]="badge().tone === 'warning'">
        {{ badge().label }}
      </span>
    }
  </header>

  @if (loading()) {
    <div class="access-card__loading" role="status" aria-label="Carregando">
      <app-cog-loading-spinner [size]="32" />
    </div>
  } @else if (errorMessage()) {
    <div class="access-card__error" role="alert">
      <p>{{ errorMessage() }}</p>
      <app-button
        label="Tentar de novo"
        icon="pi pi-refresh"
        theme="white"
        size="small"
        [type]="'button'"
        (sendButtonClick)="reload()" />
    </div>
  } @else {
    <p class="access-card__text">
      Crie o usuário do cliente e envie um link seguro para ele assinar o NDA + carta SCR direto
      pela área do cliente.
    </p>

    @if (users().length) {
      <ul class="access-card__users" aria-label="Quem já tem acesso">
        @for (user of users(); track user.email) {
          <li>
            <strong>{{ user.name || user.email }}</strong>
            <span>
              @if (user.name) {
                {{ user.email }} ·
              }
              {{ user.invitedAt | vaultDateTime }}
            </span>
          </li>
        }
      </ul>
    }

    @if (rejected()) {
      <p class="access-card__text">
        Este deal foi recusado. Para dar acesso ao cliente, o time da Legatus precisa reabrir o
        deal.
      </p>
    } @else {
      <app-button
        [label]="users().length ? 'Convidar outro contato' : 'Criar acesso e enviar link'"
        icon="pi pi-users"
        theme="darkblue"
        size="small"
        [type]="'button'"
        (sendButtonClick)="openInvite()" />
    }
  }
</section>

<app-modal-client-access #inviteModal (invited)="onInvited($event)" />
